import React from 'react';
import PropTypes from 'prop-types';

const AdminCardView = ({ admin, onEdit }) => (
  <div className='o-card__wrap o-admin-card'>
    <section className='column o-card cs-bg--light'>
      <h3><b>{admin.name}</b></h3>
      {admin.is_administrator && (<p>
        <i>Administration Level Access</i>
      </p>)}
      <p>
        Status: {admin.archived ? 'Archived' : 'Active'}
      </p>
      <p>
        Admin User Type: {admin.partner_custom_tag_association?.partner_custom_tag_label}
      </p>
      <p className='cs-txt-link--sp-blue'>
        <a href={`mailto:${admin.email}`} target='_blank' rel='noreferrer'>
          <b>{admin.email}</b>
        </a>
      </p>
      <div className='u-flex'>
        <a className='o-sp-button o-sp-button--update o-sp-button--primary' onClick={onEdit}>
          Edit
        </a>
      </div>
    </section>
  </div>
);

AdminCardView.propTypes = {
  admin: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default AdminCardView;
